import { Skeleton } from '@audio-network/componentlibrary'
import clsx from 'clsx'

import actionsStyles from '../TrackActions/TrackActions.module.css'
import artworkStyles from './TrackArtwork/TrackArtwork.module.css'
import detailsStyles from './TrackDetails/TrackDetails.module.css'
import styles from './TrackRow.module.css'
import waveformStyles from './TrackWaveform/TrackWaveform.module.css'

const TrackRowSkeleton = (): JSX.Element => {
	return (
		<div className={styles.trackRow} data-testid="track-row-skeleton">
			<Skeleton className={artworkStyles.artwork} variant="rounded" />
			<div className={detailsStyles.details}>
				<span className={detailsStyles.titleGroup}>
					<Skeleton width={200} />
				</span>
				<span className={detailsStyles.description}>
					<Skeleton width={300} />
				</span>
			</div>
			<Skeleton
				className={waveformStyles.waveform}
				height={16}
				variant="rectangular"
			/>
			<div className={actionsStyles.trackActions}>
				<Skeleton
					className={actionsStyles.trackAction}
					width={32}
					height={24}
					variant="rounded"
				/>
				<Skeleton
					className={actionsStyles.trackAction}
					width={32}
					height={24}
					variant="rounded"
				/>
				<Skeleton
					className={clsx(actionsStyles.trackAction, actionsStyles.download)}
					width={80}
					height={24}
					variant="rounded"
				/>
				<Skeleton width={32} height={24} variant="rounded" />
			</div>
		</div>
	)
}

export default TrackRowSkeleton
